import { SyntheticEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { MailIcon } from 'app/common/presentation/icons'

import { Button, Modal, ModalProps, TextField } from 'components'

import styles from './Users.module.scss'

interface InviteModalProps extends Pick<ModalProps, 'onClose' | 'open'> {
  inviteUser: (email: string) => void
  inviteUserError?: string
}

const InviteModal = ({ inviteUser, inviteUserError, open, ...modalProps }: InviteModalProps) => {
  const { t } = useTranslation('settings')

  const [email, setEmail] = useState('')

  useEffect(() => setEmail(''), [open])

  const handleInviteUser = (e: SyntheticEvent) => {
    e.preventDefault()

    inviteUser(email)
  }

  return (
    <Modal
      actions={
        <Button
          onClick={handleInviteUser}
          rightIcon={<MailIcon />}
          type="submit"
          variant="primary-gray"
        >
          {t('users.invite.action')}
        </Button>
      }
      className={styles.modal}
      open={open}
      onSubmit={handleInviteUser}
      title={t('users.invite.title')}
      {...modalProps}
    >
      <div>{t('users.invite.description')}</div>
      <div className={styles.email}>{t('users.invite.email.title')}</div>
      <TextField
        autoFocus
        className={styles.input}
        error={inviteUserError}
        onChange={setEmail}
        placeholder={t('users.invite.email.placeholder')}
        value={email}
      />
    </Modal>
  )
}

export default InviteModal
